<template>
  <div />
</template>

<script setup lang="ts">
import { useStore } from 'vuex';

const store = useStore();

let errcnt = 0;

function testImg() {
  const i = new Image();
  i.onerror = () => {
    errcnt += 1;
    if (errcnt < 3) {
      setTimeout(testImg, 250);
    } else {
      store.commit('setAdsBlocked');
    }
  };
  i.onload = () => {
    store.commit('setAdsNotBlocked');
  };

  i.src = 'https://nitropay.com/wp-content/uploads/2022/08/np-white.png';
}
testImg();
</script>
